import e from "./SchemaCollapsedPreview.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/SchemaCollapsedPreview.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaCollapsedPreview.vue.js.map